export default function ProjectPath(_: { isNewUser?: boolean }) {
	return null;
}
